import React, { useEffect } from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import CustomNavbarToggle from "../CustomNavbarToggle/CustomNavbarToggle";
import Logo from "./logo-title-white.svg";
import { usePlayer } from "../../../../contexts/PlayerContext";
import "./Navigation.css";
const Navigation = ({activeTab, setActiveTab}) => {
    const {navVisible, hasNavigation, navExpanded, toggleNavbar, hoverTimeout, setNavVisible } = usePlayer();
    useEffect(() => {
        // Attach listeners to the video player container
        const container = document.querySelector(".player-container");
        if (!container) return;
        const showNav = () => {
            if (hoverTimeout.current) clearTimeout(hoverTimeout.current);
            setNavVisible(true);
        };
        const hideNav = () => {
            hoverTimeout.current = setTimeout(() => setNavVisible(false), 200);
        };
        container.addEventListener("mouseenter", showNav);
        container.addEventListener("mouseleave", hideNav);
        container.addEventListener("touchstart", showNav);
        return () => {
            container.removeEventListener("mouseenter", showNav);
            container.removeEventListener("mouseleave", hideNav);
            container.removeEventListener("touchstart", showNav);
        };
    }, [hoverTimeout, setNavVisible]);

    if(!hasNavigation) {
        return null;
    }
    return (
        <Navbar
            expand="md"
            className={`navigation g-0 py-0 my-0 border-bottom ${
                navVisible ? "visible" : "invisible"
            }
                ${hasNavigation === true ? "" : "d-none"}`}
            style={{
                position: "absolute",
                top: 0,
                width: "100%",
                zIndex: 10000000,
            }}
            expanded={navExpanded}
        >
            <Container fluid className="g-0 my-0 py-0">
                <CustomNavbarToggle
                    onClick={() => toggleNavbar()}
                    active={navExpanded}
                />
                <Navbar.Collapse className="player-collapse g-0 my-0 py-0">
                    <Nav
                        className="me-auto"
                        activeKey={activeTab}
                        onSelect={(selectedKey) => setActiveTab(selectedKey)}
                    >
                        <Nav.Item
                            className="player-nav-item px-4 py-2 position-relative"
                            style={{
                                backgroundColor:
                                    activeTab === "live"
                                        ? "rgb(255, 255, 255)"
                                        : "",
                            }}
                        >
                            <Nav.Link
                                eventKey="live"
                                className={`position-relative player-nav-item`}
                                style={{
                                    backgroundColor:
                                        activeTab === "live"
                                            ? "rgb(255, 255, 255)"
                                            : "",
                                }}
                            >
                                Live
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="player-nav-item px-4 py-2"
                            style={{
                                backgroundColor:
                                    activeTab === "recordings"
                                        ? "rgb(255, 255, 255)"
                                        : "",
                            }}
                        >
                            <Nav.Link
                                eventKey="recordings"
                                className={`${
                                    activeTab === "recordings" ? "active" : ""
                                }`}
                            >
                                Recordings
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Navbar.Collapse>
                <Navbar.Brand
                    href="https://churchcamlive.ie"
                    rel="noopener"
                    target="_blank"
                >
                    <img
                        src={Logo}
                        alt="church cam live logo"
                        style={{ maxWidth: "120px" }}
                    />
                </Navbar.Brand>
            </Container>
        </Navbar>
    );
};

export default Navigation;
